<hr/>

<div class="sitewrapper py-4">
    <div class="row">
        <div class="col-md-9 col-12">
            <img alt="PayHOA" src="/assets/images/payhoa/marketing/logo-white.svg"/>
            <a class="d-inline-block ml-4" href="https://www.payhoa.com/terms-conditions/" target="_blank">Terms of use</a>
            <a class="d-inline-block ml-4" href="https://www.payhoa.com/privacy-policy/" target="_blank">Privacy policy</a>
        </div>
        <div class="col-md-3 col-12 text-right">
            <span>&copy; {{today}} PayHOA, LLC</span>
        </div>
    </div>
</div>
